import { Appearance } from '@stripe/stripe-js'

const appearance: Appearance = {
    theme: 'flat',
    variables: {
        fontFamily: 'MMC, sans-serif',
        fontLineHeight: '1.5',
        borderRadius: '0px',
        colorBackground: '#F6F6F6',
        colorPrimaryText: '#333',
        colorIconTabHover: '#fff',
        colorIconTabSelected: '#fff',
    },
    rules: {
        '.Block': {
            backgroundColor: '#fff',
            boxShadow: 'none',
            padding: '12px',
        },
        '.Input': {
            padding: '12px',
            border: '1px solid #333',
        },
        '.Input:disabled, .Input--invalid:disabled': {
            color: 'lightgray',
        },
        '.AccordionItem': {
            padding: '12px',
            border: '1px solid #333',
        },
        '.AccordionItem:hover': {
            backgroundColor: '#333',
            color: '#fff',
        },
        '.AccordionItem--selected, .AccordionItem--selected:focus, .AccordionItem--selected:hover': {
            backgroundColor: '#fff',
            color: '#333',
        },
        '.AccordionItem--selected:focus': {
            boxShadow:
                '0 0 0 0.5px var(--colorPrimaryText), 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)',
        },
        '.Label': {
            text: '#fff',
        },
        '.Dropdown': {
            border: '1px solid #333',
            backgroundColor: '#fff',
        },
    },
}
export default appearance
